import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

const card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const quickBtn = { display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 16, background: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }

const Card = function({ title, value, color, size = 'normal' }) {
  return (
    <div style={{
      background: '#fff',
      padding: size === 'small' ? 16 : 20,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      textAlign: 'center'
    }}>
      <div style={{ color: '#999', fontSize: size === 'small' ? 11 : 12, marginBottom: 8 }}>{title}</div>
      <div style={{ fontSize: size === 'small' ? 24 : 32, color, fontWeight: 'bold' }}>{value}</div>
    </div>
  );
};

export default function HQDashboard() {
  const [stats, setStats] = useState({
    totalOrders: 0,
    totalRevenue: 0,
    totalEnrollments: 0,
    totalChildren: 0,
    totalPartners: 0,
    totalInstitutions: 0,
    totalBases: 0,
    monthOrders: 0,
    totalCustomers: 0,
    totalProducts: 0
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch(`${API}/analytics/overview`)
      .then(r => r.json())
      .then(d => {
        if (d.success && d.data) {
          const data = d.data
          setStats({
            totalOrders: data.orders?.total || 0,
            totalRevenue: data.orders?.revenue || 0,
            totalEnrollments: data.learners?.total || 0,
            totalChildren: data.learners?.total || 0,
            totalPartners: 0,
            totalInstitutions: data.customers?.total || 0,
            totalBases: data.bases?.total || 0,
            monthOrders: data.orders?.monthly || 0,
            totalCustomers: data.customers?.total || 0,
            totalProducts: data.products?.total || 0
          })
        }
      })
      .catch(err => {
        console.error('加载失败', err)
        if (d.success) {
          setStats({
            totalOrders: d.data.customers?.total || 0,
            totalRevenue: d.data.products?.total || 0,
            totalEnrollments: d.data.learners?.total || 0,
            totalChildren: d.data.customers?.total || 0,
            totalPartners: d.data.partners?.total || 0,
            totalInstitutions: d.data.institutions?.total || 0,
            totalBases: d.data.bases?.total || 0,
            monthOrders: d.data.activities?.total || 0
          })
        }
      })
      .catch(err => console.error('获取数据失败', err))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>加载中...</div>

  return (
    <div style={{ padding: 24 }}>
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>🏢 总部总览</h2>

      {/* 核心数据 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <Card title="总订单" value={stats.totalOrders} color="#1890ff" />
        <Card title="总收入" value={`¥${(stats.totalRevenue || 0).toLocaleString()}`} color="#52c41a" />
        <Card title="学员数" value={stats.totalEnrollments} color="#722ed1" />
        <Card title="客户数" value={stats.totalCustomers} color="#fa8c16" />
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>客户总数</div>
          <div style={{ fontSize: 32, color: '#1890ff' }}>{stats.totalOrders}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>产品总数</div>
          <div style={{ fontSize: 32, color: '#52c41a' }}>{stats.totalRevenue}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>学员总数</div>
          <div style={{ fontSize: 32, color: '#722ed1' }}>{stats.totalEnrollments}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>活动总数</div>
          <div style={{ fontSize: 32, color: '#fa8c16' }}>{stats.monthOrders}</div>
        </div>
      </div>

      {/* 机构与基地 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}>
        <Card title="合伙人" value={stats.totalPartners} color="#eb2f96" size="small" />
        <Card title="机构数" value={stats.totalInstitutions} color="#13c2c2" size="small" />
        <Card title="基地数" value={stats.totalBases} color="#faad14" size="small" />
        <Card title="产品数" value={stats.totalProducts} color="#1890ff" size="small" />
      </div>

      {/* 快捷入口说明 */}
      <div style={{ marginTop: 32, background: '#f6ffed', padding: 16, borderRadius: 8, border: '1px solid #b7eb8f' }}>
        <div style={{ fontSize: 14, color: '#52c41a', marginBottom: 8 }}>💡 提示</div>
        <div style={{ fontSize: 13, color: '#666' }}>
          点击左侧菜单可访问各功能模块：数据分析、客户管理、订单管理、合伙人管理、机构管理、IP运营中心等
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>合伙人</div>
          <div style={{ fontSize: 24, color: '#eb2f96' }}>{stats.totalPartners}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>机构数</div>
          <div style={{ fontSize: 24, color: '#13c2c2' }}>{stats.totalInstitutions}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>基地数</div>
          <div style={{ fontSize: 24, color: '#faad14' }}>{stats.totalBases}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>本月活动</div>
          <div style={{ fontSize: 24, color: '#1890ff' }}>{stats.monthOrders}</div>
        </div>
      </div>

      <div style={{ marginTop: 24, background: '#fff', borderRadius: 8, padding: 20 }}>
        <h3 style={{ marginBottom: 16 }}>快捷入口</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12 }}>
          {[
            { label: '产品管理', icon: '📦', page: 'products' },
            { label: '客户管理', icon: '👥', page: 'customers' },
            { label: '合伙人', icon: '🤝', page: 'institution-partner' },
            { label: '数据分析', icon: '📊', page: 'analytics' },
          ].map(item => (
            <button key={item.page} style={quickBtn} onClick={() => window.dispatchEvent(new CustomEvent('navigate', { detail: item.page }))}>
              <span style={{ fontSize: 24 }}>{item.icon}</span>
              <span style={{ fontSize: 13, marginTop: 8 }}>{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
    </div>
    </div>
  )
}
